import React from "react";
import Image from "@airasia/phoenix-components/components/Image";

function ImageWrapper({ imageData }) {
  return (
    <Image
      accessible
      centerFocus={false}
      enableProgressiveImageLoading={false}
      height="auto"
      lazyLoadImage={false}
      radius="0px"
      src={imageData.image}
      theme="AIRASIA_CLASSIC"
      width="100%"
      customProperties={{id: 'partners'}}
    />
  );
}

export default ImageWrapper;
